{
  "#ARTIKELSTAMM": {
    "TITLE": "Artikelstamm",
    "SEARCH": "Suche",
    "TAB": {
      "ALLGEMEIN": {
        "TITLE": "Allgemein",
        "PRODUCT_DATA_PANEL": {
          "TITLE": "Artikeldaten",
          "MAIN_GROUP": "Hauptgruppe",
          "SUB_GROUP": "Untergruppe",
          "PRODUCT_GROUP": "Produktgruppe",
          "TAX": "Steuer",
          "FIBU_GROUP_VK": "Fibugruppe Verkauf",
          "FIBU_GROUP_EK": "Fibugruppe Einkauf",
          "KZ_LISTED": "Kzgelistet",
          "ITEM_TYPE": "Artikelart",
          "PLANT_PROTECTION_REG_NUMBER": "Pflanzenschutz-Registernummer",
          "STORAGE": "Lager",
          "LISTING_DATE": "Datum der Einlistung",
          "DELISTING_DATE": "Datum der Auslistung",
          "DELETE_DATE": "Löschdatum",
          "LAST_CHANGED_DATE": "Änderungsdatum"
        },
        "UNIT_PANEL": {
          "TITLE": "Einheiten",
          "UNIT": "Einheit",
          "DESCRIPTION": "Beschreibung",
          "FACTOR": "Faktor",
          "EAN": "EAN",
          "NOT_FOUND": "Es wurden keine Einheiten gefunden..."
        },
        "PROMOTION_PANEL": {
          "TITLE": "Aktionen",
          "SHOW_ALL_PROMOTIONS": {
            "TITLE": "Alle Aktionen anzeigen",
            "SUB_TITLE": "Historische Daten einblenden"
          }
        },
        "SALE_PANEL": {
          "TITLE": "Verkaufspreis"
        },
        "SUPPLIER_PANEL": {
          "TITLE": "Einkaufspreis"
        }
      },
      "EINKAUF": {
        "TITLE": "Einkauf",
        "SUPPLIER_PRICES_PANEL": {
          "TITLE": "Einkaufsinformationen",
          "SUB_TITLE": "Einkaufspreise",
          "SHOW_ALL_PRICES": {
            "TITLE": "Alle Preise anzeigen",
            "SUB_TITLE": "Historische Daten einblenden"
          },
          "SUPPLIER": "Lieferant",
          "SUPPLIER_DESC": "Beschreibung",
          "STATUS": "Status",
          "DELIVERY_UNIT": "Liefer-EH",
          "LISTED": "Gelistet",
          "DELIVERY_PROD_NUMBER": "Lief.-Art.-Nr.",
          "EAN": "EAN",
          "CURRENCY": "Preis-EH",
          "MIN_QUANTITY": "Mindestbestellmenge",
          "DELIVERY_DAYS": "Liefertage",
          "INFO": "Info"
        }
      },
      "VERKAUF": {
        "TITLE": "Verkauf",
        "VK_PROMOTIONS_PANEL" : {
          "TITLE": "VK Aktionspreise",
          "SHOW_ALL_PROMOTIONS": {
            "TITLE": "Alle Aktionen anzeigen",
            "SUB_TITLE": "Historische Daten einblenden"
          }
        },
        "UNIT_PANEL": {
          "TITLE": "Einheiten",
          "SUB_TITLE": "Verkaufspreise",
          "SHOW_ALL_PRICES": {
            "TITLE": "Alle Preise anzeigen",
            "SUB_TITLE": "Historische Daten einblenden"
          },
          "UNIT": "Einheit",
          "DESCRIPTION": "Bezeichnung",
          "FACTOR": "Faktor",
          "EAN": "EAN"
        }
      },
      "ARTIKELTEXTE": {
        "TITLE": "Artikeltexte",
        "PREPARATION": "Zubereitung",
        "INGREDIENT": "Zutaten",
        "DECLARATION": "Deklaration",
        "QS_COMMENT": "QS Kommentar",
        "PRODUCTION": "Produktion",
        "PE_NUMBER": "PE Nummer",
        "PRODUCT_TEXT": "Produkttext"
      }
    },
    "SHARED_TABLES": {
      "SALES_PROMOTION": {
        "PROMOTION": "Aktion",
        "START_DATE": "Von",
        "END_DATE": "Bis",
        "PAGE": "Seite",
        "SUPPLIER": "Lieferant",
        "SUPPLIER_DESCRIPTION": "Lieferant Bez.",
        "ORDER_QUANTITY": "Bestellmenge",
        "UNIT": "Einheit",
        "STAFFEL": "Staffel",
        "PER": "Per",
        "SUPPLIER_BRUTTO": "Brutto EK",
        "SUPPLIER_KONDITION": "EK Kondition",
        "SUPPLIER_NETTO": "Netto EK",
        "MARGIN": "Spanne",
        "ADVERTISING_PRICE": "Werbepreis Inkl."
      },
      "SALES_PRODUCT": {
        "UNIT": "EH",
        "START_DATE": "Ab Datum",
        "CURRENCY": "Währung",
        "TAX": "UST",
        "STAFFEL": "Staffel",
        "UVP_INCL": "UVP (Inkl)",
        "UVP_EXCL": "UVP (Exkl)",
        "MARGIN": "Spanne",
        "SUPPLIER_NETTO": "Netto EK"
      },
      "SUPPLIER_PRODUCT": {
        "VERTRIEBSWEG": "Vertriebsweg",
        "START_DATE": "Ab Datum",
        "CURRENCY": "Währung",
        "PER": "Per",
        "STAFFEL": "Staffel",
        "BRUTTO": "Brutto EK",
        "KONDITION": "Kondition",
        "NETTO": "Netto EK",
        "MARGIN": "Spanne",
        "UVP_INCL": "UVP (Inkl.)"
      }
    }
  }
}
